export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/course/createcourse',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allCourses'],
       
    })
